import PropTypes from 'prop-types';
import ItemCard from '../ItemCard';
import OwlCarousel from 'react-owl-carousel';

const internals = {};

internals.sliderOptions = {
  className: 'owl-theme',
  touchDrag: true,
  mouseDrag: true,
  lazyLoad: true,
  nav: false,
  items: 2,
  dotsEach: 4,
  autoplay: true,
  animateOut: 'slideOutUp',
  animateIn: 'slideInUp',
  responsive: {
    768: {
      nav: true,
      items: 3,
      dotsEach: 3,
    }
  },
};

export default class SuggestedPanel extends React.Component {
  static propTypes = {
    suggestedItems: PropTypes.array,
    showSuggested: PropTypes.bool,
    userId: PropTypes.number,
    showSuggestedHandler: PropTypes.func,
    modalUpdateHandler: PropTypes.func,
    isSuccessAddedHandler: PropTypes.func
  };

  static defaultProps = {
    suggestedItems: [],
    showSuggested: false,
    userId: null
  };
  constructor(props) {
    super(props);

    this.state = {
      suggestedItems: []
    };
  }
  static getDerivedStateFromProps(newProps, state) {
    const itemChanged = (state.suggestedItems !== newProps.suggestedItems);

    if (itemChanged) {

      return {
        ...state,
        ...newProps
      };
    }

    return null;
  }
  componentDidMount() {
    $('.suggested-loader').hide();
    $('.suggested-container').show();
  }
  shouldComponentUpdate(nextProps) {
    if (nextProps.suggestedItems !== this.state.suggestedItems) {
      return true;
    }
    if (this.props.showSuggested !== nextProps.showSuggested) {
      return true;
    }

    return false;
  }
  componentDidUpdate(nextProps) {
    if (this.props.suggestedItems !== nextProps.suggestedItems) {
      $('.suggested-loader').hide();
      $('.suggested-container').show();
    }
  }

  _renderItems = (suggestedItems) =>  suggestedItems.map((item) => <ItemCard key={ item.attributeId } itemData = { item } isGrid={false} userId={this.props.userId} modalUpdateHandler={this.props.modalUpdateHandler} isSuccessAddedHandler={this.props.isSuccessAddedHandler}/> );

  _getSubCategoryName = (suggestedItems) => suggestedItems.map((item) => item.subcategoryName).slice(0, 1);

  render() {
    const { showSuggested, showSuggestedHandler } = this.props;
    const itemsCount = this.state.suggestedItems.length;
    const items = this._renderItems(this.state.suggestedItems);
    const subCategory = this._getSubCategoryName(this.state.suggestedItems);
    const keyId = this.state.suggestedItems.map((item) => (item.id)).join();


    return (
      <div>
        <div className={'suggested-container container-fluid'}>
          <div className="row">
            <h3 className="xs-9 lg-10 more-items">{`other ${itemsCount} ${subCategory} you may also love:`}</h3>
            <a className={`xs-2 show-hide display-block uppercase ${showSuggested}`} onClick={ showSuggestedHandler }/>
          </div>
          <div className={`items-container row ${showSuggested && 'show-items'}`}>
            <OwlCarousel key={`carousel-${keyId}`} {...internals.sliderOptions} >
              {items}
            </OwlCarousel>
          </div>
        </div>
      </div>
    );
  }
}
